import { MailIcon } from 'de-suite-me-ui'

export default MailIcon
